<style lang="less" scoped>
.display-flex {
    display: flex;
}
.flex-1 {
    flex: 1;
}
.component-contain {
  display: inline-block;
  width: 280px;
  height: 200px;
}
.index-dismantle-contian {
    text-align: center;
    .header-contain {
      margin:10px;
      flex-direction: row;
      .select-contain {
        min-width: 476px;
        text-align: right;
      }
      .header-remark {
        text-align: left;
      }
    }
    .level-1 {
       //  display: inline;
    }
    .gap-1 {
        height: 100px;
    }
    .level-2 {
        position: relative;
        .mark {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
        }
    }
    .level-3 {
        display: flex;
        .half {
            flex:1;
            .half-contain {
              display: flex;
              .half-contain-flex {
                flex: 1;
              }
            }
        }
        .mark-contain {
          .common-mark {
            position: relative;
            display: block;
            margin: -8px auto 0;
            width: 280px;
            height: 135px;
          }
          .common-level-mark {
              transform: translateY(-50%);
              position: absolute;
              display: flex;
              height: 135px;
              width: 200%;
          }
          .mark-1 {
            height: 280px;
            border-left: 1px solid #D7DAE2;
            .mark-1-contain {
              top: 280px;
              .mark-line-left {
                margin-right: -8px;
              }
            }
          }
          .mark-line {
            width: 10px;
            height: 50%;
            border-bottom: 1px solid #D7DAE2;
          }
          .mark-item {
            flex: 1;
            margin: auto 5px;
            height: 108px;
          }
          .mark-2 {
            height: 120px;
            border-right: 1px solid #D7DAE2;
            .mark-2-contain {
              top: 120px;
              right: 0px;
              .mark-line-right {
                margin-left: -8px;
              }
            }
          }
        }
    }
    
}
</style>
<template>
  <div 
    class="index-dismantle-contian"
  >
    <Spin
      v-if="loading.getHistoryDataDecomposeLoading"
      size="large"
      fix
    />
    <div 
      class="display-flex header-contain"
    >
      <div 
        v-show="params.product_type===1"
        class="header-remark"
      >
        <p>该页面所有指标仅包含<strong>【自营商城】</strong>的实体电商销售数据；</p>
        <p>淘宝天猫因为没有用户数据，所以不能统计用户数以及客单价等指标</p>
      </div>
      <div class="flex-1 select-contain">
        <IconMark />
        <DatePicker
          v-model="params.month"
          :clearable="false"
          type="month"
          placeholder="请选择月份"
          style="width: 150px;margin-right:10px;padding-left:12px"
          @on-change="getData"
        />
        <Select
          v-model="params.team_id"
          style="width:150px;margin-right:10px"
          @on-change="getData"
        >
          <Option
            v-for="item in teamsList"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </Option>
        </Select>
        <Select
          v-model="params.product_type"
          style="width:150px"
          @on-change="getData"
        >
          <Option
            v-for="item in subject_fields" 
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </Option>
        </Select>        
      </div>
    </div>
    <div class="level-1">
      <div class="component-contain">
        <Element 
          ref="sale"
          :item-props="sale"
        />
      </div>
    </div>
    <div class="gap-1 ">
      <Division />
    </div>
    <div class="level-2 display-flex">
      <div class="flex-1">
        <div class="component-contain">
          <Element 
            ref="perCustomerTransaction"
            :item-props="perCustomerTransaction"
          />
        </div>
      </div>
      <div class="flex-1">
        <div class="component-contain">
          <Element 
            ref="userNumber"
            :item-props="userNumber"
          />
        </div>
      </div>
      <div class="mark">
        <Icon
          :size="50"
          type="md-close"
        />
      </div>
    </div>
    <div class="gap-1 display-flex">
      <div class="flex-1">
        <Division />
      </div>
      <div class="flex-1">
        <Division />
      </div>
    </div>
    <div class="level-3">
      <div class="half">
        <div class="half-contain">
          <div class="half-contain-flex">
            <div class="component-contain">
              <!-- skuPerCustomerTransaction -->
              <Element 
                ref="skuPerCustomerTransaction"
                :item-props="skuPerCustomerTransaction"
              />
            </div>            
          </div>
          <div class="half-contain-flex">
            <div class="component-contain">
              <!--  -->
              <Element 
                ref="goodsQuantityCustomer"
                :item-props="goodsQuantityCustomer"
              />
            </div>
          </div>            
        </div>
      </div>
      <div class="half">
        <div class="half-contain">
          <div class="half-contain-flex">
            <div class="component-contain">
              <Element 
                ref="oldUserNumber"
                :item-props="oldUserNumber"
              />
            </div>
          </div>
          <div class="half-contain-flex">
            <div class="component-contain">
              <Element 
                ref="newUserNumber"
                :item-props="newUserNumber"
              />
            </div>
          </div>
        </div>
        <div
          v-if="params.product_type===0"
          class="half-contain"
        >
          <!-- class="half-contain-flex" -->
          <div class="half-contain-flex mark-contain">
            <div class="mark-1 common-mark">
              <div class="mark-1-contain common-level-mark ">
                <div class="mark-line mark-line-left" />
                <div class="mark-item">
                  <MarkElement :mark-props="oldLowPriceTotal" />
                </div>
                <div class="mark-item">
                  <MarkElement :mark-props="oldParPriceTotal" />
                </div>
                <div class="mark-item">
                  <MarkElement :mark-props="oldHighPriceTotal" />
                </div>
              </div>
            </div>
          </div>
          <div class="half-contain-flex mark-contain">
            <div class="mark-2 common-mark">
              <div class="mark-2-contain common-level-mark ">
                <div class="mark-item">
                  <MarkElement :mark-props="newLowPriceTotal" />
                </div>
                <div class="mark-item">
                  <MarkElement :mark-props="newParPriceTotal" />
                </div>
                <div class="mark-item">
                  <MarkElement :mark-props="newHighPriceTotal" />
                </div>
                <div class="mark-line mark-line-right" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import MarkElement from './MarkElement'
  import Element from './Element.vue'
  import Division from './Division.vue'
  import IconMark from './IconMark.vue'
  import { mapActions, mapState, mapMutations } from 'vuex'
  import { NAME_SPACE } from './../constants'
  import { subject_fields, default_value, default_mark_value } from './indexDismantle_fields'
  import { formattingNumber } from './../utils'
  const refs_list = [
    'sale',
    'perCustomerTransaction',
    'userNumber',
    'skuPerCustomerTransaction',
    'goodsQuantityCustomer',
    'oldUserNumber',
    'newUserNumber'
  ]
  export default {
    components: { Element, Division, MarkElement, IconMark },
    props: {},
    data() {
      this.subject_fields = subject_fields
      return {
        params: {
          month: moment().format('YYYY-MM'),
          product_type: 0,
          team_id: 'all'
        }
      }
    },
    computed:{
      ...mapState(NAME_SPACE, {
        loading:'loading',
        changeTag: 'changeTag',
        overviewData: 'overviewData',
        historyDataDecompose: 'historyDataDecompose',
        teamList: 'teamList'
      }),
      sale() {
        return this.setProps({
          historyDataDecompose: this.historyDataDecompose,
          key: 'income',
          title: '销售额（万元）',
          num_digit: 10000,
          offset_num: 10000
        }) 
      },
      teamsList() {
        const item = {
          name:'集团整体',
          id: 'all'
        }
        return [item, ...this.teamList]
      },
      /* -------------------------------  element相关组件  ---------------------------- */
      perCustomerTransaction() {
        return this.setProps({
          historyDataDecompose: this.historyDataDecompose,
          key: 'unit_price',
          title: '客单价',
          d_count_digit:2
        }) 
      },
      skuPerCustomerTransaction() {
        return this.setProps({
          historyDataDecompose: this.historyDataDecompose,
          key: 'sku_unit_price',
          title: 'SKU客单价',
          d_count_digit:2
        })
      },
      goodsQuantityCustomer() {
        return this.setProps({
          historyDataDecompose: this.historyDataDecompose,
          key: 'unit_qty',
          title: '商品数量/用户',
          d_count_digit:2,
          minInterval:0.1
        }) 
      },
      userNumber() {
        return this.setProps({
          historyDataDecompose: this.historyDataDecompose,
          key: 'user',
          title: '用户数',
          d_count_digit:0,
          num_digit: 1,
          offset_num: 1000
        }) 
      },
      oldUserNumber() {
        return this.setProps({
          historyDataDecompose: this.historyDataDecompose,
          key: 'old_user',
          title: '老用户数',
          d_count_digit:0,
          num_digit: 1,
          offset_num: 1000
        }) 
      },
      newUserNumber() {
        return this.setProps({
          historyDataDecompose: this.historyDataDecompose,
          key: 'new_user',
          title: '新用户数',
          d_count_digit:0,
          num_digit: 1,
          offset_num: 1000
        }) 
      },
      /* -------------------------------  MarkElement相关组件  ---------------------------- */
      oldLowPriceTotal() {
        return this.setMarkProps(
          '购买低价课老用户数量',
          this.historyDataDecompose,
          'old_user_low',
          'old_user'
        )
      },
      oldParPriceTotal() {
        return this.setMarkProps(
          '购买平价课老用户数量',
          this.historyDataDecompose,
          'old_user_middle',
          'old_user'
        )
      },
      oldHighPriceTotal() {
        return this.setMarkProps(
          '购买高价课老用户数量',
          this.historyDataDecompose,
          'old_user_high',
          'old_user'
        )
      },
      newLowPriceTotal() {
        return this.setMarkProps(
          '购买低价课新用户数量',
          this.historyDataDecompose,
          'new_user_low',
          'new_user'
        )
      },
      newParPriceTotal() {
        return this.setMarkProps(
          '购买平价课新用户数量',
          this.historyDataDecompose,
          'new_user_middle',
          'new_user'
        )
      },
      newHighPriceTotal() {
        return this.setMarkProps(
          '购买高价课新用户数量',
          this.historyDataDecompose,
          'new_user_high',
          'new_user'
        )
      },
    },
    watch: {
      'changeTag.historyDataDecomposeChangeIndex'() {// 当取到数据后统一更新Element组件中的 echarts
        this.$nextTick(() => {
          this.setEcharts()
          // this.setEchartsResize()
        })
      }
    },
    mounted() {
      refs_list.forEach(key => {
        this.addEchartsResize(this.$refs[key].getResize())
      })
    },
    methods:{
      resizeEchart() {
        this.resizeCall(refs_list.map(key => this.$refs[key].getResize()))
      },
      // 获取整个组件所需要的数据
      getData() {
        this.$nextTick(() => {
          const paramsClone = {...this.params}
          if (paramsClone.team_id === 'all') {
            delete paramsClone.team_id
          }
          this.getHistoryDataDecompose(paramsClone)
        })
           
      },
      // 生成各个element组件的props
      setProps(
        {
          historyDataDecompose,
          key,
          title,
          d_count_digit = 0,
          num_digit = 1,
          offset_num = 1,
          minInterval    
        }) {
        if (!historyDataDecompose) {
          return default_value
        }
        const current_source_data = historyDataDecompose[key]
        const current = Number(current_source_data.current || 0) / num_digit
        const last_month = Number(current_source_data.last_month || 0) / num_digit
        const d_percent = last_month !== 0 ? `${(Math.abs((current - last_month) / last_month) * 100).toFixed(2)}%` : '-'
        return {
          title,
          number: formattingNumber(current, d_count_digit),
          d_percent,
          d_count: formattingNumber(Math.abs(current - last_month), d_count_digit),
          isRise: current > last_month,
          line_data: current_source_data.line_data.map(item => Number(item[1]) / offset_num),
          minInterval
        }
      },
      setMarkProps(title, historyDataDecompose, key, skey) {
        if (!historyDataDecompose || !historyDataDecompose.course_users || !historyDataDecompose.course_users[key]) {
          return default_mark_value
        }
        const current_data = historyDataDecompose.course_users[key].current || 0
        const last_data = historyDataDecompose.course_users[key].last_month || 0
        const total = historyDataDecompose[skey].current
        const percent = !total ? '-' : `${((current_data / total) * 100).toFixed(2)}%`
        const toPercent = !last_data ? '-' : `${((Math.abs(current_data - last_data) / last_data) * 100).toFixed(2)}%`
        return {
          title,
          num: formattingNumber(current_data),
          percent,
          isRise:current_data >= last_data,
          toPercent,
        }
      },
      // 更新所有的element组件中的echarts元素
      setEcharts() {
        refs_list.forEach(key => {
          this.$refs[key].updateEcharts()
        })
      },
      // setEchartsResize () {
      //   refs_list.forEach(key => {
      //     this.$refs[key].resize()
      //   })
      // },
      ...mapMutations(NAME_SPACE,
                      [
                        'addEchartsResize',
                        'resizeCall'
                      ]),
      ...mapActions(NAME_SPACE, [
        'getHistoryDataDecompose',
      ]),
    },
  }
</script>
